export default __webpack_public_path__ + "static/media/ava-default.6382802c.jpeg";